import { CanvasIconTypes } from '@workday/design-assets-types';
var icon = {
    name: 'caretRightSmall',
    type: CanvasIconTypes.System,
    svg: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" class="wd-icon-caret-right-small wd-icon" focusable="false" role="presentation" viewBox="0 0 24 24"><g fill-rule="evenodd" class="wd-icon-container"><path d="M15.866 12.288c.18.117.177.31 0 .424l-6.538 4.235c-.18.116-.328.034-.328-.176V8.229c0-.214.15-.29.328-.176z" class="wd-icon-fill"/></g></svg>',
    filename: 'wd-icon-caret-right-small.svg',
    category: 'Core',
    tags: ['navigation', 'arrow', 'triangle', 'data', 'table', 'grid'],
};
export default icon;
